/* =========================================================
   HeroPack Blog Scroll + Mobile Links Fix v6
   Replace the full contents of Assets / hp-blog-scroll-fix.js with this.
   ========================================================= */
(function () {
  var STYLE_ID = 'hp-blog-scroll-links-fix-v6';

  function isBlogListPage() {
    return window.location.pathname.indexOf('/blogs/') !== -1 &&
      !!document.querySelector('#MainContent .blog-articles, #MainContent [class*="blog"]');
  }

  function isMobile() {
    return window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
  }

  function injectStyle() {
    var old = document.getElementById(STYLE_ID);
    if (old) old.remove();

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
html.hp-blog-list-clean #MainContent .blog-articles,
html.hp-blog-list-clean #MainContent .blog-articles__article,
html.hp-blog-list-clean #MainContent .article-card,
html.hp-blog-list-clean #MainContent .card-wrapper,
html.hp-blog-list-clean #MainContent .card,
html.hp-blog-list-clean #MainContent .card__inner,
html.hp-blog-list-clean #MainContent .card__content,
html.hp-blog-list-clean #MainContent .card__information{
  overflow:visible!important;
  overflow-y:visible!important;
  overflow-x:hidden!important;
  height:auto!important;
  max-height:none!important;
  scrollbar-width:none!important;
  -ms-overflow-style:none!important;
}

html.hp-blog-list-clean #MainContent .blog-articles *::-webkit-scrollbar,
html.hp-blog-list-clean #MainContent .blog-articles__article *::-webkit-scrollbar,
html.hp-blog-list-clean #MainContent .article-card *::-webkit-scrollbar,
html.hp-blog-list-clean #MainContent .card-wrapper *::-webkit-scrollbar,
html.hp-blog-list-clean #MainContent .card *::-webkit-scrollbar{
  display:none!important;
  width:0!important;
  height:0!important;
}

html.hp-blog-list-clean #MainContent .article-card__excerpt,
html.hp-blog-list-clean #MainContent .card__information .rte,
html.hp-blog-list-clean #MainContent .card__information p{
  display:-webkit-box!important;
  -webkit-line-clamp:3!important;
  -webkit-box-orient:vertical!important;
  overflow:hidden!important;
  overflow-y:hidden!important;
  overflow-x:hidden!important;
  max-height:calc(1.65em * 3)!important;
  direction:rtl!important;
  text-align:center!important;
  color:#334155!important;
  font-family:Assistant,Arial,sans-serif!important;
  font-size:15px!important;
  line-height:1.65!important;
}

html.hp-blog-list-clean #MainContent .card__heading,
html.hp-blog-list-clean #MainContent .card__heading a{
  direction:rtl!important;
  text-align:center!important;
  color:#0E1B4D!important;
  -webkit-text-fill-color:#0E1B4D!important;
  font-family:Assistant,Arial,sans-serif!important;
  font-size:22px!important;
  line-height:1.25!important;
  font-weight:800!important;
  text-decoration:none!important;
}

/* Critical mobile link fix */
@media screen and (max-width:749px){
  html.hp-blog-list-clean #MainContent,
  html.hp-blog-list-clean #MainContent *,
  html.hp-blog-list-clean #MainContent .blog-articles__article,
  html.hp-blog-list-clean #MainContent .article-card,
  html.hp-blog-list-clean #MainContent .card-wrapper,
  html.hp-blog-list-clean #MainContent .card,
  html.hp-blog-list-clean #MainContent .card__content,
  html.hp-blog-list-clean #MainContent .card__information{
    pointer-events:auto!important;
  }

  html.hp-blog-list-clean #MainContent .blog-articles__article a,
  html.hp-blog-list-clean #MainContent .article-card a,
  html.hp-blog-list-clean #MainContent .card-wrapper a,
  html.hp-blog-list-clean #MainContent .card a,
  html.hp-blog-list-clean #MainContent a[href*="/blogs/"]{
    pointer-events:auto!important;
    position:relative!important;
    z-index:9999!important;
    cursor:pointer!important;
    touch-action:manipulation!important;
  }
}
`;
    document.head.appendChild(style);
  }

  function mark() {
    if (isBlogListPage()) document.documentElement.classList.add('hp-blog-list-clean');
  }

  function normalizeCards() {
    if (!isBlogListPage()) return;
    mark();
    injectStyle();

    document.querySelectorAll('#MainContent .blog-articles__article, #MainContent .article-card, #MainContent .card-wrapper, #MainContent .card').forEach(function (card) {
      card.style.setProperty('pointer-events', 'auto', 'important');
      card.style.setProperty('overflow', 'visible', 'important');
      card.style.setProperty('height', 'auto', 'important');
      card.style.setProperty('max-height', 'none', 'important');

      card.querySelectorAll('a[href]').forEach(function (a) {
        a.style.setProperty('pointer-events', 'auto', 'important');
        a.style.setProperty('position', 'relative', 'important');
        a.style.setProperty('z-index', '9999', 'important');
      });
    });
  }

  function mobileCardClickFallback(e) {
    if (!isMobile() || !isBlogListPage()) return;

    var link = e.target.closest && e.target.closest('#MainContent a[href*="/blogs/"]');
    if (link && link.href) {
      e.preventDefault();
      e.stopPropagation();
      window.location.href = link.href;
      return;
    }

    var card = e.target.closest && e.target.closest('#MainContent .blog-articles__article, #MainContent .article-card, #MainContent .card-wrapper, #MainContent .card');
    if (!card) return;

    var firstLink = card.querySelector('a[href*="/blogs/"]') || card.querySelector('a[href]');
    if (firstLink && firstLink.href) {
      e.preventDefault();
      e.stopPropagation();
      window.location.href = firstLink.href;
    }
  }

  function run() {
    normalizeCards();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('click', mobileCardClickFallback, true);

  window.addEventListener('load', function () {
    setTimeout(run, 100);
    setTimeout(run, 500);
    setTimeout(run, 1200);
  });

  window.addEventListener('resize', function () {
    setTimeout(run, 150);
  });

  document.addEventListener('shopify:section:load', function () {
    setTimeout(run, 150);
  });
})();
